import React from 'react';
import { motion } from 'framer-motion';
import 'react-phone-input-2/lib/style.css';

export const StepWizard = ({ step, setStep, steps }) => {
    return (
        <div className="relative w-full p-2 sm:p-4 md:p-10 overflow-x-auto">
            {/* Step Wizard Container */}
            <div className="flex flex-row justify-start sm:justify-between w-full relative z-10 min-w-max sm:min-w-0 px-2">
                {steps.map((stepItem, index) => {
                    const isActive = stepItem.number === step;
                    const isCompleted = stepItem.number < step;
                    const isUpcoming = stepItem.number === step + 1;

                    return (
                        <div 
                            key={stepItem.number} 
                            className="relative flex-1 text-center min-w-[100px] sm:min-w-0 px-2 sm:px-0"
                        >
                            {/* Step Indicator */}
                            <motion.div
                                className={`w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 mx-auto rounded-full 
                                    flex items-center justify-center font-semibold transition-colors duration-300 
                                    ${isActive
                                        ? 'bg-gradient-to-r from-gradientStart to-tblue text-white shadow-lg'
                                        : isCompleted
                                            ? 'bg-tblue text-white'
                                            : 'bg-bodyMain border text-body'
                                    }`}
                                animate={isActive ? {
                                    scale: [1, 1.1, 1],
                                    rotate: [0, 10, -10, 0],
                                    boxShadow: [
                                        '0px 0px 10px rgba(156, 39, 176, 0.4)',
                                        '0px 0px 20px rgba(156, 39, 176, 0.6)',
                                        '0px 0px 30px rgba(156, 39, 176, 0.4)',
                                    ]
                                } : isUpcoming ? {
                                    boxShadow: [
                                        '0px 0px 5px rgba(156, 39, 176, 0.4)',
                                        '0px 0px 10px rgba(156, 39, 176, 0.6)',
                                        '0px 0px 5px rgba(156, 39, 176, 0.4)'
                                    ]
                                } : {}}
                                transition={{
                                    duration: 1.5,
                                    repeat: isActive || isUpcoming ? Infinity : 0,
                                    repeatType: "reverse",
                                    ease: "easeInOut",
                                }}
                                whileHover={isCompleted ? { scale: 1.1 } : {}}
                                onClick={() => isCompleted && setStep(stepItem.number)}
                            >
                                <span className="text-xs sm:text-sm md:text-base">
                                    {stepItem.number}
                                </span>
                            </motion.div>

                            {/* Step Label */}
                            <p className={`mt-2 text-xs sm:text-sm md:text-base font-semibold tracking-wide 
                                transition-colors duration-300 whitespace-nowrap
                                ${isActive 
                                    ? 'text-indigo-500' 
                                    : isCompleted 
                                        ? 'text-gray-500' 
                                        : 'text-gray-400'
                                }`}
                            >
                                {stepItem.label}
                            </p>

                            {/* Connector Line - Hidden on smallest screens */}
                            {index < steps.length - 1 && (
                                <motion.div
                                    className="absolute top-4 sm:top-5 md:top-6 left-1/2 w-full h-0.5 sm:h-1 
                                        transform -translate-y-1/2 hidden sm:block"
                                    initial={{ width: '0%' }}
                                    animate={{
                                        width: isCompleted ? '100%' : isActive ? '0%' : '0%',
                                        backgroundColor: isCompleted 
                                            ? 'rgb(99, 102, 241)' 
                                            : 'rgb(209, 213, 219)',
                                    }}
                                    transition={{ duration: 0.5 }}
                                    style={{ zIndex: -1 }}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};